import { IconTrash } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { IntegrationRow } from '../lib/integrations';
import { ConfirmDialog } from './ConfirmDialog';

// Disconnect confirmation for one connector (spec §3.6, tinted destructive
// action) — pure presenter; the parent owns the mutation. `row === null` keeps
// the dialog closed. A failed disconnect surfaces as the parent's error toast
// while the dialog stays open, so the destructive action never silently no-ops.

export type DisconnectIntegrationModalProps = {
  readonly row: IntegrationRow | null;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
};

export function DisconnectIntegrationModal(props: DisconnectIntegrationModalProps): JSX.Element {
  return (
    <ConfirmDialog
      open={props.row !== null}
      title={t('integrations.disconnect_title')}
      desc={t('integrations.disconnect_body', {
        name: props.row ? t(`integrations.kind.${props.row.kind}`) : '',
      })}
      media={<IconTrash />}
      cancelLabel={t('integrations.cancel')}
      actionLabel={t('integrations.disconnect')}
      destructive
      onCancel={props.onClose}
      onConfirm={props.onConfirm}
    />
  );
}
